import gql from 'graphql-tag'

export const getCandidateGAs = gql`
  query($paging: PagingQuery, $filter: GeneralAgentsFilter!) {
    getGeneralAgents(
      filter: $filter,
      paging: $paging
    ) {
      generalAgents {
        id
        name
      }
    }
  }
`

export const getGeneralAgents = gql`
  query($filter: GeneralAgentsFilter!, $paging: PagingQuery, $order: GeneralAgentsOrder) {
    getGeneralAgents(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      generalAgents {
        id
        name
        hoursOfOperation
        policyTypes
        amBestRating
        notes
        website
        username
        password
        producerCode
        directAppointment
        primaryAddressState
        primaryAddressCity
        primaryAddressZipCode
        primaryAddressStreet1
        primaryAddressStreet2
        email
        phone
        countryCode
        countryCallingCode
        extensionNumber
        fax
        faxCountryCode
        faxCountryCallingCode
        faxExtensionNumber
        policyDocumentsDelivery
        downloads
        endorsementDocumentDelivery
        createdAt
        updatedAt
      }
      paging { totalCount currentOffset currentLimit }
    }
  }
`

export const getGeneralAgent = gql`
  query($generalAgentId: Int!) {
    getGeneralAgent(
      generalAgentId: $generalAgentId
    ) {
      id
      name
      hoursOfOperation
      policyTypes
      amBestRating
      notes
      website
      username
      password
      producerCode
      directAppointment
      primaryAddressState
      primaryAddressCity
      primaryAddressZipCode
      primaryAddressStreet1
      primaryAddressStreet2
      email
      phone
      countryCode
      countryCallingCode
      extensionNumber
      fax
      faxCountryCode
      faxCountryCallingCode
      faxExtensionNumber
      policyDocumentsDelivery
      downloads
      endorsementDocumentDelivery
      createdAt
      updatedAt
      lastModifiedBy {
        id
        username
      }
      createdBy {
        id
        username
      }
    }
  }
`

export const newGeneralAgent = gql`
  mutation($generalAgentInput: GeneralAgentInput!) {
    newGeneralAgent(
      generalAgentInput: $generalAgentInput
    ) {
      id
    }
  }
`

export const editGeneralAgent = gql`
  mutation($generalAgentInput: GeneralAgentInput!, $generalAgentId: Int!) {
    editGeneralAgent(
      generalAgentId: $generalAgentId,
      generalAgentInput: $generalAgentInput
    ) {
      id
    }
  }
`

export const deleteGeneralAgent = gql`
  mutation($generalAgentId: Int!) {
    deleteGeneralAgent(
      generalAgentId: $generalAgentId
    )
  }
`
